<script>
export default {
  name: 'SearchStatus',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#5E7266',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/bold/search-status">
      <g id="search-status">
        <path
          id="Vector"
          d="M11.8893 2C6.47228 2 2.06836 6.26 2.06836 11.5C2.06836 16.74 6.47228 21 11.8893 21C17.3063 21 21.7103 16.74 21.7103 11.5C21.7103 6.26 17.3063 2 11.8893 2ZM11.8893 13.75H8.78795C8.3641 13.75 8.01262 13.41 8.01262 13C8.01262 12.59 8.3641 12.25 8.78795 12.25H11.8893C12.3132 12.25 12.6646 12.59 12.6646 13C12.6646 13.41 12.3132 13.75 11.8893 13.75ZM14.9907 10.75H8.78795C8.3641 10.75 8.01262 10.41 8.01262 10C8.01262 9.59 8.3641 9.25 8.78795 9.25H14.9907C15.4145 9.25 15.766 9.59 15.766 10C15.766 10.41 15.4145 10.75 14.9907 10.75Z"
          :fill="color"
        />
        <path
          id="Vector_2"
          d="M22.0196 21.9986C21.8335 21.9986 21.6474 21.9286 21.513 21.7986L19.5902 19.9386C19.3111 19.6686 19.3111 19.2286 19.5902 18.9486C19.8693 18.6786 20.3242 18.6786 20.6136 18.9486L22.5365 20.8086C22.8156 21.0786 22.8156 21.5186 22.5365 21.7986C22.3918 21.9286 22.2057 21.9986 22.0196 21.9986Z"
          :fill="color"
        />
      </g>
    </g>
  </svg>
</template>
